import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Join from './components/Join';
import Lore from './components/Lore';
import Apps from './components/Apps';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ElDesguace from './components/ElDesguace';
import SecretShop from './components/SecretShop';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <About />
            <Apps />
            <Join />
          </>
        } />
        <Route path="/lore" element={<Lore />} />
        <Route path="/el-desguace" element={<ElDesguace />} />
        <Route path="/secret-shop" element={<SecretShop />} />
      </Routes>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
